// import React, { useEffect, useState } from "react";
// import { Form, Input, Button, Typography, Row, Col, DatePicker, Spin, message, Select } from "antd";
// import { LeftOutlined, RightOutlined } from "@ant-design/icons";
// import { useHistory, useLocation } from "react-router-dom";
// import LeftLayout from "../../pageHeader/LeftLayout";
// import { routes } from "../../../routes/Routes";
// import PhoneInput from "react-phone-input-auto-format";
// import AlphabetInput from "../../../components/AlphabetInput";
// import { COMMON_ERROR_MSG } from "../../../constants/constants";
// import moment from "moment";
// import _consumerService from "../../../modules/consumerService";
// import IntegerInput from "../../../components/IntergerInput";

// const { Title } = Typography;
// const { Option } = Select;

// const ConsumerPersonalDetails = () => {
//     const [loading, setLoading] = useState(false);
//     const history = useHistory();
//     const consumerId = localStorage.getItem("ConsumerUserId");
//     const [personalInfo, setPersonalInfo] = useState({});
//     const [applicanttypes, setApplicanttypes] = useState([]);

//     const [form] = Form.useForm();
//     const location = useLocation();
//     let data = location.state;
//     let consumerIdFromProfile = "";
//     let fromDashboard = false;

//     if (data && data.consumerId) {
//         consumerIdFromProfile = data.consumerId;
//     }

//     if (data && data.isFromDashboard) {
//         fromDashboard = data.isFromDashboard;
//     }

//     const [consumerFromProfileID] = useState(consumerIdFromProfile);
//     const [isFromDashboard] = useState(fromDashboard);


//     useEffect(() => form.resetFields(), [personalInfo]);

//     useEffect(() => {
//         getpersonalDetailsById();
//         getApplicantTypes();
//     }, []);

//     const getApplicantTypes = async () => {
//         try {
//             const res = await _consumerService.getAllDropdownDataByName("applicanttypes");
//             if (res.data) {
//                 setApplicanttypes(res.data);
//             }
//         } catch (e) {
//             console.log(e);

//         }
//     };

//     const onFinish = async (values) => {
//         const midadleFirstLetter = values.middleInitial?.charAt(0).toUpperCase();
//         try {
//             setLoading(true)
//             const reqObj = {
//                 Id: consumerFromProfileID ? consumerFromProfileID : consumerId,
//                 ScreenName: "aapplicationdetails",
//                 App_Det_Application_Type_Id: values.applicationType,
//                 App_Det_FirstName: values.firstName,
//                 App_Det_MiddleInitial: midadleFirstLetter != "" ? midadleFirstLetter : null,
//                 App_Det_LastName: values.lastName,
//                 App_Det_DateOfBirth: values.dob ? moment(values.dob).format("YYYY-MM-DD") : null,
//                 App_Det_ContactNumber: values.contactNumber,
//                 Ident_City: values.identCity,
//                 Ident_State: values.identState,
//                 Ident_ZipCode: values.identZipCode,
//                 Prof_Employer_Name: values.employerName,
//                 Prof_JobRole: values.employerPositionTitle,
//                 Prof_NO_Years: values.numberOfYearsWithEmployer
//             }
//             const res = await _consumerService.updateConsumerData(reqObj);
//             if (res.data.IsSuccess) {
//                 localStorage.setItem("consumerFirstName", values.firstName);
//                 setLoading(false);
//                 if (isFromDashboard) {
//                     history.push({ pathname: routes.consumerProfile.path, state: { consumerId } });
//                 } else {
//                     history.push(routes.consumerDashboard.path);
//                 }
//                 message.success(res.data.Message)
//             } else {
//                 setLoading(false);
//                 message.error(res.data.Message || COMMON_ERROR_MSG);
//             }
//         } catch (err) {
//             console.log(err);
//             setLoading(false)
//         }
//     };

//     const onBack = () => {
//         history.push({ pathname: routes.consumerProfile.path, state: { consumerId } });
//     };

//     const getpersonalDetailsById = async () => {
//         setLoading(true);
//         try {
//             const resObj = await _consumerService.getConsumerInformationByConsumerId(consumerFromProfileID ? consumerFromProfileID : consumerId);
//             if (resObj.data) {
//                 const res = resObj.data;
//                 console.log("res", res);
//                 setPersonalInfo({
//                     applicationType: res?.App_Det_Application_Type_Id ? res.App_Det_Application_Type_Id : null,
//                     firstName: res?.App_Det_FirstName,
//                     middleInitial: res?.App_Det_MiddleInitial,
//                     lastName: res?.App_Det_LastName,
//                     dob: res?.App_Det_DateOfBirth ? moment(res.App_Det_DateOfBirth) : null,
//                     contactNumber: res?.App_Det_ContactNumber,
//                     email: res?.Email,
//                     identState: res?.Ident_State,
//                     identCity: res?.Ident_City,
//                     identZipCode: res?.Ident_ZipCode,
//                     employerName: res?.Prof_Employer_Name,
//                     employerPositionTitle: res?.Prof_JobRole,
//                     numberOfYearsWithEmployer: res?.Prof_NO_Years
//                 });
//                 setLoading(false);
//             }
//         } catch (e) {
//             setLoading(false);
//             console.log(e);
//         }

//     }

//     const disableFutureDates = (current) => {
//         return current && current > moment().startOf("day");
//     };

//     return (
//         <Spin spinning={loading}>
//             <LeftLayout>
//                 <div className="form-parent-div inputBoxStyle">
//                     <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3" }}>
//                         Investor Portal
//                     </Title>

//                     <Title level={4} style={{ marginBottom: 24 }}>
//                         Personal Details
//                     </Title>

//                     <Form
//                         form={form}
//                         layout="vertical"
//                         onFinish={onFinish}
//                         requiredMark={true}
//                         initialValues={personalInfo}
//                     >
//                         <Row gutter={16} >
//                             <Col xs={24} sm={24} md={8} lg={8} xl={8} >
//                                 <Form.Item
//                                     label="First Name"
//                                     name="firstName"
//                                     rules={[{ required: true, message: "First Name is required" }]}
//                                 >
//                                     <AlphabetInput placeholder="Enter First Name" maxLength={30} />
//                                 </Form.Item>
//                             </Col>
//                             <Col xs={24} sm={24} md={8} lg={8} xl={8}>
//                                 <Form.Item
//                                     label="Middle Initial"
//                                     name="middleInitial"
//                                 // rules={[
//                                 //     { required: true, max: 1, message: "Only one character allowed" },
//                                 // ]}
//                                 >
//                                     <AlphabetInput placeholder="Enter Middle Initial" maxLength={1} />
//                                 </Form.Item>
//                             </Col>
//                             <Col xs={24} sm={24} md={8} lg={8} xl={8}>
//                                 <Form.Item
//                                     label="Last Name"
//                                     name="lastName"
//                                     rules={[{ required: true, message: "Last Name is required" }]}
//                                 >
//                                     <AlphabetInput placeholder="Enter Last Name" maxLength={30} />
//                                 </Form.Item>
//                             </Col>


//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="Application Type"
//                                     name="applicationType"
//                                     rules={[{ required: true, message: "Application Type is required" }]}

//                                 >
//                                     <Select
//                                         placeholder="Select Application Type"
//                                     >
//                                         {applicanttypes?.map((obj) => (
//                                             <Option key={obj.Id} value={obj.Id}>
//                                                 {obj.Name}
//                                             </Option>
//                                         ))}

//                                     </Select>
//                                 </Form.Item>
//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="Date Of Birth"
//                                     name="dob"

//                                     rules={[{ required: true, message: "Date Of Birth is required" }]}
//                                 >
//                                     <DatePicker
//                                         allowClear
//                                         inputReadOnly={false}
//                                         style={{ width: "100%" }}
//                                         format="MM/DD/YYYY"
//                                         placeholder="MM/DD/YYYY"
//                                         disabledDate={(current) => {
//                                             return current && current >= moment().startOf("day");
//                                         }}
//                                     />
//                                 </Form.Item>
//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="Contact Number"
//                                     name="contactNumber"

//                                     rules={[
//                                         { required: true, message: "Contact Number is required" },
//                                         {
//                                             validator: (_, value) => {
//                                                 if (!value) {
//                                                     return Promise.resolve(); //  Allow empty value if not required
//                                                 }
//                                                 const digits = value.replace(/\D/g, '');
//                                                 if (digits.length === 10) {
//                                                     return Promise.resolve();
//                                                 }
//                                                 return Promise.reject(
//                                                     new Error("Wrong format! please use this format (XXX) XXX-XXXX")
//                                                 );
//                                             },
//                                         }
//                                     ]}
//                                 >
//                                     <PhoneInput
//                                         placeholder="Enter Contact Number"
//                                         inputComponent={Input}
//                                         autoComplete="off"
//                                         onChange={(value) => {
//                                             // Remove non-digit characters and store the raw number
//                                             const digits = value.replace(/\D/g, '');
//                                             form.setFieldsValue({ contactNumber: digits });
//                                         }}
//                                     />
//                                 </Form.Item>

//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="Email"
//                                     name="email"
//                                     rules={[
//                                         { required: false, message: "Email address is required" },
//                                         {
//                                             type: "email",
//                                             message: "Please enter a valid email address",
//                                         },
//                                     ]}

//                                 >
//                                     <Input
//                                         placeholder="Enter Email"
//                                         maxLength={50}
//                                         disabled
//                                     />
//                                 </Form.Item>
//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="City"
//                                     name="identCity"

//                                     rules={[
//                                         { required: true, message: "City is required" }
//                                     ]}
//                                 >
//                                     <Input
//                                         placeholder="Enter City"
//                                         maxLength={30}
//                                     />
//                                 </Form.Item>

//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="State"
//                                     name="identState"

//                                     rules={[
//                                         { required: true, message: "State is required" }
//                                     ]}
//                                 >
//                                     <Input
//                                         placeholder="Enter State"
//                                         maxLength={50}
//                                     />
//                                 </Form.Item>

//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="Zip Code"
//                                     name="identZipCode"

//                                     rules={[
//                                         {
//                                             required: true,
//                                             message: 'Zip Code is required',
//                                         }
//                                     ]}
//                                 >
//                                     <IntegerInput placeholder="Enter Zip Code" maxLength={10} />
//                                 </Form.Item>

//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="Employer Name"
//                                     name="employerName"

//                                 >
//                                     <Input
//                                         placeholder="Enter Employer Name"
//                                         maxLength={30}
//                                     />
//                                 </Form.Item>

//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="Position/Title"
//                                     name="employerPositionTitle"

//                                 >
//                                     <Input
//                                         placeholder="Enter Position/Title"
//                                         maxLength={30}
//                                     />
//                                 </Form.Item>

//                             </Col>
//                             <Col xs={24} sm={24} md={12} lg={12} xl={12} >
//                                 <Form.Item
//                                     label="Number of Years with Employer"
//                                     name="numberOfYearsWithEmployer"

//                                 >
//                                     <IntegerInput
//                                         placeholder="Enter Number of Years with Employer"
//                                         maxLength={30}
//                                     />
//                                 </Form.Item>

//                             </Col>
//                             <Col xs={24} sm={24} md={24} lg={24} xl={24} >
//                                 <Form.Item>
//                                     <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: 20 }}>
//                                         {isFromDashboard &&
//                                             <Button
//                                                 onClick={onBack}
//                                                 icon={<LeftOutlined />}
//                                             >
//                                                 Go Back
//                                             </Button>
//                                         }
//                                         <Button
//                                             type="primary"
//                                             htmlType="submit"
//                                         >
//                                             {isFromDashboard ? "Save And Proceed" : "Create Profile"}  <RightOutlined />
//                                         </Button>
//                                     </div>
//                                 </Form.Item>
//                             </Col>
//                         </Row>
//                     </Form>

//                 </div>
//             </LeftLayout>
//         </Spin>
//     );
// };

// export default ConsumerPersonalDetails;



import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, Row, Col, DatePicker, Spin, message, Select, Divider } from "antd";
import { UserOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined, CalendarOutlined, IdcardOutlined, BankOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import { routes } from "../../../routes/Routes";
import PhoneInput from "react-phone-input-auto-format";
import AlphabetInput from "../../../components/AlphabetInput";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import moment from "moment";
import _consumerService from "../../../modules/consumerService";
import IntegerInput from "../../../components/IntergerInput";

const { Title, Text } = Typography;
const { Option } = Select;

const ConsumerPersonalDetails = () => {

    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const consumerId = localStorage.getItem("ConsumerUserId");
    const [personalInfo, setPersonalInfo] = useState({});
    const [applicanttypes, setApplicanttypes] = useState([]);

    const [form] = Form.useForm();
    const location = useLocation();
    let data = location.state;
    let consumerIdFromProfile = "";
    let fromDashboard = false;

    if (data && data.consumerId) {
        consumerIdFromProfile = data.consumerId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    const [consumerFromProfileID] = useState(consumerIdFromProfile);
    const [isFromDashboard] = useState(fromDashboard);


    useEffect(() => form.resetFields(), [personalInfo]);

    useEffect(() => {
        getpersonalDetailsById();
        getApplicantTypes();
    }, []);

    const getApplicantTypes = async () => {
        try {
            const res = await _consumerService.getAllDropdownDataByName("applicanttypes");
            if (res.data) {
                setApplicanttypes(res.data);
            }
        } catch (e) {
            console.log(e);

        }
    };

    const onFinish = async (values) => {
        const midadleFirstLetter = values.middleInitial?.charAt(0).toUpperCase();
        try {
            setLoading(true)
            const reqObj = {
                Id: consumerFromProfileID ? consumerFromProfileID : consumerId,
                ScreenName: "aapplicationdetails",
                App_Det_Application_Type_Id: values.applicationType,
                App_Det_FirstName: values.firstName,
                App_Det_MiddleInitial: midadleFirstLetter != "" ? midadleFirstLetter : null,
                App_Det_LastName: values.lastName,
                App_Det_DateOfBirth: values.dob ? moment(values.dob).format("YYYY-MM-DD") : null,
                App_Det_ContactNumber: values.contactNumber,
                Ident_City: values.identCity,
                Ident_State: values.identState,
                Ident_ZipCode: values.identZipCode,
                Prof_Employer_Name: values.employerName,
                Prof_JobRole: values.employerPositionTitle,
                Prof_NO_Years: values.numberOfYearsWithEmployer
            }
            const res = await _consumerService.updateConsumerData(reqObj);
            if (res.data.IsSuccess) {
                localStorage.setItem("consumerFirstName", values.firstName);
                setLoading(false);
                if (isFromDashboard) {
                    history.push({ pathname: routes.consumerProfile.path, state: { consumerId } });
                } else {
                    history.push(routes.consumerDashboard.path);
                }
                message.success(res.data.Message)
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
            setLoading(false)
        }
    };

    const onBack = () => {
        history.push({ pathname: routes.consumerProfile.path, state: { consumerId } });
    };

    const getpersonalDetailsById = async () => {
        setLoading(true);
        try {
            const resObj = await _consumerService.getConsumerInformationByConsumerId(consumerFromProfileID ? consumerFromProfileID : consumerId);
            if (resObj.data) {
                const res = resObj.data;
                console.log("res", res);
                setPersonalInfo({
                    applicationType: res?.App_Det_Application_Type_Id ? res.App_Det_Application_Type_Id : null,
                    firstName: res?.App_Det_FirstName,
                    middleInitial: res?.App_Det_MiddleInitial,
                    lastName: res?.App_Det_LastName,
                    dob: res?.App_Det_DateOfBirth ? moment(res.App_Det_DateOfBirth) : null,
                    contactNumber: res?.App_Det_ContactNumber,
                    email: res?.Email,
                    identState: res?.Ident_State,
                    identCity: res?.Ident_City,
                    identZipCode: res?.Ident_ZipCode,
                    employerName: res?.Prof_Employer_Name,
                    employerPositionTitle: res?.Prof_JobRole,
                    numberOfYearsWithEmployer: res?.Prof_NO_Years
                });
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }

    }

    const disableFutureDates = (current) => {
        return current && current > moment().startOf("day");
    };

    return (
        <LeftLayout>
            <Spin spinning={loading}>
                <div className="profile-wrapper">
                    <div className="profile-card">
                        <Title level={3} className="card-title">Personal Details</Title>
                        <Text className="card-subtitle">Complete your profile to finish registration</Text>

                        <Form
                            layout="vertical"
                            form={form}
                            onFinish={onFinish}
                            initialValues={personalInfo}
                            requiredMark={true}
                        >
                            <Row gutter={[16, 0]}>
                                {/* First Name + Middle Initial */}
                                <Col xs={24} md={16}>
                                    <Form.Item name="firstName" label="First Name" rules={[{ required: true }]}>
                                        <Input className="dark-input" prefix={<UserOutlined />} />
                                    </Form.Item>
                                </Col>
                                {/* <Col xs={24} md={8}>
                                    <Form.Item name="middleInitial" label="Middle Initial">
                                        <Input className="dark-input" maxLength={1} />
                                    </Form.Item>
                                </Col> */}

                                <Col xs={24} md={8}>
                                    <Form.Item
                                        label="Middle Initial"
                                        name="middleInitial"
                                    >
                                        <Input
                                            className="dark-input middle-initial-input"
                                            maxLength={1}
                                            placeholder=""
                                        />
                                    </Form.Item>
                                </Col>

                                {/* Last Name */}
                                <Col xs={24}>
                                    <Form.Item name="lastName" label="Last Name" rules={[{ required: true }]}>
                                        <Input className="dark-input" prefix={<UserOutlined />} />
                                    </Form.Item>
                                </Col>

                                {/* Application Type */}
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        name="applicationType"
                                        label="Application Type"
                                        rules={[{ required: true, message: "Please select type" }]}
                                    >
                                        <Select className="dark-select" placeholder="Select Application Type">
                                            {applicanttypes.map((obj) => (
                                                <Option key={obj.Id} value={obj.Id}>{obj.Name}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                {/* Date of Birth */}
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label="Date Of Birth"
                                        name="dob"

                                        rules={[{ required: true, message: "Date Of Birth is required" }]}
                                    >
                                        <DatePicker
                                            className="dark-input"
                                            allowClear
                                            inputReadOnly={false}
                                            style={{ width: "100%" }}
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                            disabledDate={(current) => {
                                                return current && current >= moment().startOf("day");
                                            }}
                                        />
                                    </Form.Item>
                                </Col>



                                {/* Contact Number */}
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label="Contact Number"
                                        name="contactNumber"

                                        rules={[
                                            { required: true, message: "Contact Number is required" },
                                            {
                                                validator: (_, value) => {
                                                    if (!value) {
                                                        return Promise.resolve(); //  Allow empty value if not required
                                                    }
                                                    const digits = value.replace(/\D/g, '');
                                                    if (digits.length === 10) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                                    );
                                                },
                                                }
                                        ]}
                                    >
                                        <PhoneInput
                                            prefix={<PhoneOutlined />}
                                            className="dark-input"
                                            placeholder="Enter Contact Number"
                                            inputComponent={Input}
                                            autoComplete="off"
                                            onChange={(value) => {
                                                // Remove non-digit characters and store the raw number
                                                const digits = value.replace(/\D/g, '');
                                                form.setFieldsValue({ contactNumber: digits });
                                            }}
                                        />
                                    </Form.Item>
                                </Col>

                                {/* Email */}
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label="Email"
                                        name="email"

                                        rules={[
                                            { required: false, message: "Email address is required" },
                                            {
                                                type: "email",
                                                message: "Please enter a valid email address",
                                            },
                                        ]}

                                    >
                                        <Input
                                            className="dark-input"
                                            prefix={<MailOutlined />}
                                            placeholder="Enter Email"
                                            maxLength={50}
                                            disabled
                                        />
                                    </Form.Item>
                                </Col>

                                {/* City, State, Zip */}
                                <Col xs={24} md={8}>
                                    <Form.Item name="identCity" label="City" rules={[{ required: true }]}>
                                        <Input className="dark-input" prefix={<EnvironmentOutlined />} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item name="identState" label="State" rules={[{ required: true }]}>
                                        <Input
                                            prefix={<EnvironmentOutlined />}
                                            className="dark-input"

                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} md={8}>
                                    <Form.Item
                                        label="Zip Code"
                                        name="identZipCode"
                                        rules={[
                                            { required: true, message: "Zip Code is required" },

                                        ]}
                                    >
                                        <Input
                                            className="dark-input zip-input"
                                            placeholder="Enter Zip Code"
                                            maxLength={10}
                                        />
                                    </Form.Item>
                                </Col>
                             
                                    <Divider className="employmentInfoDivider"></Divider>
                             

                                {/* Employment Section */}
                                <Col span={24} className="mb20 mt20">
                                    <Text className="section-title">Employment Information</Text>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item name="employerName" label="Employer Name">
                                        <Input
                                            prefix={<BankOutlined />}
                                            className="dark-input"
                                            placeholder="Enter Employer Name"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item name="employerPositionTitle" label="Position/Title">
                                        <Input
                                            className="dark-input"
                                            placeholder="Enter Position/Title"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>

                                    <Form.Item name="numberOfYearsWithEmployer" label="Number of Years with Employer"
                                        rules={[
                                                {
                                                    pattern: /^(?:0|[1-9][0-9]?)(?:\.(?:[1-9]|1[0-1]))?$/,
                                                    message: 'Enter a valid number of years (e.g., 5, 10.3, 12.11)',
                                                },
                                            ]}
                                    >
                                        <Input
                                            className="dark-input"
                                            placeholder="Enter Years"
                                            
                                        />
                                    </Form.Item>
                                </Col>

                                {/* Submit Button */}
                                <Col span={24}>
                                    <Button type="primary" htmlType="submit" className="submit-btn createProfileButton" block>
                                        Create Profile →
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </Spin>
        </LeftLayout>
    );
};

export default ConsumerPersonalDetails;
